function isImageUrlValid(url, callback) {
    var img = new Image();

    img.onload = function () {
        callback(true);
    };

    img.onerror = function () {
        callback(false);
    };

    img.src = url;
}